import { FC, useCallback, useMemo } from 'react';
import cls from 'classnames';
import { useTranslation } from 'react-i18next';
import { WordItem } from './word-item';
import { SearchWord } from 'shared/models';
import { useViewTracking } from '~/utils/use-view-tracking';
import { useScopedAtomValue } from '@lemon8/web-app-shared/ssr';
import { $CurrentPageModule } from '~/models/current-page-module';
import { $CurrentModuleRank, MODULE_NOT_RANK } from '~/models/current-module-rank';

import './style.scss';

interface IProps {
  words: SearchWord[];
  className?: string;
}

export const SearchWords: FC<IProps> = ({ words, className }) => {
  const { t } = useTranslation();

  const currentPageModule = useScopedAtomValue($CurrentPageModule);
  const currentModuleRank = useScopedAtomValue($CurrentModuleRank);

  const ref = useViewTracking({
    onView: useCallback(() => {
      const params: Record<string, any> = { current_page_module: currentPageModule };

      if (currentModuleRank !== MODULE_NOT_RANK) {
        params['module_rank'] = currentModuleRank;
      }

      window.Tea('wap_module_show', params);
    }, []),
  });

  if (words.length <= 1) {
    return null;
  }

  const list = useMemo(() => {
    let arr = words;

    if (arr.length % 2 !== 0) {
      arr = arr.slice(0, -1);
    }

    if (arr.length > 6) {
      arr = arr.slice(0, 6);
    }

    return arr;
  }, [words]);

  return (
    <div className={cls('search-words', className)} ref={ref}>
      <div className="search-words-title">{`🔍 ${t('seo_popular_keyword_title')}`}</div>
      <div className="search-words-list">
        {list.map((word, index) => {
          return <WordItem key={word.word} item={word} index={index} moduleRank={currentModuleRank} />;
        })}
      </div>
    </div>
  );
};
